export const textStyles = {
  components: {
    Heading: {
      baseStyle: {
        fontFamily: "'Vazirmatn', sans-serif",
        fontWeight: 'bold',
        textAlign: 'right',
        direction: 'rtl'
      },
      variants: {
        h1: {
          fontSize: ['2xl', '3xl', '4xl'],
          fontWeight: 'bold',
          lineHeight: '1.2'
        },
        h2: {
          fontSize: ['xl', '2xl', '3xl'],
          fontWeight: 'bold',
          lineHeight: '1.3'
        },
        h3: {
          fontSize: ['lg', 'xl', '2xl'],
          fontWeight: 'bold',
          lineHeight: '1.4'
        },
        h4: {
          fontSize: ['md', 'lg', 'xl'],
          fontWeight: 'bold',
          lineHeight: '1.5'
        },
        h5: {
          fontSize: ['sm', 'md', 'lg'],
          fontWeight: 'bold',
          lineHeight: '1.6'
        },
        h6: {
          fontSize: ['xs', 'sm', 'md'],
          fontWeight: 'bold',
          lineHeight: '1.6'
        }
      },
      defaultProps: {
        variant: 'h4'
      }
    },
    Text: {
      baseStyle: {
        fontFamily: "'Vazirmatn', sans-serif",
        textAlign: 'right',
        direction: 'rtl'
      }
    }
  }
};
